import { Amplify } from 'aws-amplify'

Amplify.configure({
    Auth: {
        Cognito: {
            // Pool configurable por env (para apuntar a dev/staging); fallback al pool de producción.
            userPoolId: process.env.REACT_APP_AWS_COGNITO_USERPOOL_ID || 'sa-east-1_yLqZZdTya',
            userPoolClientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID || '448s373aojrmvrocjog4k883og'
        }
    }
})

const AuthCognito = () => Amplify.getConfig()
export default AuthCognito